import type { NewItem } from "schemas";
import { apiRequest } from "../apiRequest";
import { setNewItems } from "./setNewItems";

export async function getNewItems() {
  const newItems = await apiRequest<NewItem>({ url: "business/newItems" });
  setNewItems(newItems);
}
